// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__tf3zW"};